module.exports = __webpack_public_path__ + "static/media/whatsapp-icono.c8d28410.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/whatsapp-icono.svg
// module id = 1876
// module chunks = 0